import React from 'react';
import Slider from 'react-slick';

const TestimonialSection = ({ activeTab = "student" }) => {
  const testimonials = {
    student: [
      {
        name: "Priya Sharma",
        location: "Varanasi",
        quote: "My tutor helped me excel in Mathematics with personalized attention!",
        rating: 4.5,
      },
      {
        name: "Rahul Verma",
        location: "Lucknow",
        quote: "Learning Science became so easy with my patient and knowledgeable tutor.",
        rating: 4.8,
      },
      {
        name: "Anjali Gupta",
        location: "Prayagraj",
        quote: "The best English tutor I could ask for - improved my grades significantly!",
        rating: 4.7,
      },
      {
        name: "Suresh Kumar",
        location: "Delhi",
        quote: "Physics was a mystery until my tutor broke it down for me!",
        rating: 4.6,
      },
      {
        name: "Meena Patel",
        location: "Mumbai",
        quote: "My grades in History soared thanks to my dedicated tutor.",
        rating: 4.9,
      },
    ],
    tutor: [
      {
        name: "Vikram Singh",
        location: "Agra",
        quote: "Teaching students here has been rewarding both financially and personally.",
        rating: 4.6,
      },
      {
        name: "Neha Pandey",
        location: "Kanpur",
        quote: "Flexible hours and great support make this platform amazing for tutors.",
        rating: 4.9,
      },
      {
        name: "Amit Mishra",
        location: "Varanasi",
        quote: "I love shaping young minds and earning a good income simultaneously!",
        rating: 4.8,
      },
      {
        name: "Ritu Jain",
        location: "Jaipur",
        quote: "The platform connects me with eager students seamlessly.",
        rating: 4.7,
      },
      {
        name: "Karan Malhotra",
        location: "Chennai",
        quote: "Teaching here has boosted my confidence and income!",
        rating: 4.5,
      },
    ],
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const stars = [];
    
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(
          <svg key={i} className="w-5 h-5 text-yellow-400" viewBox="0 0 24 24" fill="currentColor">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.9998 17.27L17.1698 20.39C17.5498 20.62 18.0198 20.28 17.9198 19.85L16.5498 13.97L21.1098 10.02C21.4398 9.72997 21.2698 9.17997 20.8198 9.13997L14.8098 8.62997L12.4598 3.08997C12.2898 2.67997 11.7098 2.67997 11.5398 3.08997L9.18981 8.62997L3.17981 9.13997C2.73981 9.17997 2.55981 9.72997 2.89981 10.02L7.45981 13.97L6.08981 19.85C5.98981 20.28 6.45981 20.62 6.83981 20.39L11.9998 17.27Z" />
          </svg>
        );
      } else if (i === fullStars && hasHalfStar) {
        stars.push(
          <svg key={i} className="w-5 h-5 text-yellow-400" viewBox="0 0 24 24" fill="none">
            <defs>
              <linearGradient id="half">
                <stop offset="50%" stopColor="#facc15" />
                <stop offset="50%" stopColor="#4a4a4a" />
              </linearGradient>
            </defs>
            <path fill="url(#half)" fillRule="evenodd" clipRule="evenodd" d="M11.9998 17.27L17.1698 20.39C17.5498 20.62 18.0198 20.28 17.9198 19.85L16.5498 13.97L21.1098 10.02C21.4398 9.72997 21.2698 9.17997 20.8198 9.13997L14.8098 8.62997L12.4598 3.08997C12.2898 2.67997 11.7098 2.67997 11.5398 3.08997L9.18981 8.62997L3.17981 9.13997C2.73981 9.17997 2.55981 9.72997 2.89981 10.02L7.45981 13.97L6.08981 19.85C5.98981 20.28 6.45981 20.62 6.83981 20.39L11.9998 17.27Z" />
          </svg>
        );
      } else {
        stars.push(
          <svg key={i} className="w-5 h-5 text-gray-400" viewBox="0 0 24 24" fill="currentColor">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.9998 17.27L17.1698 20.39C17.5498 20.62 18.0198 20.28 17.9198 19.85L16.5498 13.97L21.1098 10.02C21.4398 9.72997 21.2698 9.17997 20.8198 9.13997L14.8098 8.62997L12.4598 3.08997C12.2898 2.67997 11.7098 2.67997 11.5398 3.08997L9.18981 8.62997L3.17981 9.13997C2.73981 9.17997 2.55981 9.72997 2.89981 10.02L7.45981 13.97L6.08981 19.85C5.98981 20.28 6.45981 20.62 6.83981 20.39L11.9998 17.27Z" />
          </svg>
        );
      }
    }
    return stars;
  };

  // Slider settings
  const settings = {
    dots: true, // Show navigation dots
    infinite: true, // Loop the carousel
    speed: 500, // Transition speed in ms
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll per transition
    autoplay: true, // Enable automatic sliding
    autoplaySpeed: 3000, // Time between slides in ms
    arrows: false, // Hide navigation arrows
    responsive: [
      {
        breakpoint: 1024, // Large screens (lg)
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Medium screens (md)
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="py-16 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-14 left-10 w-24 h-24 bg-blue-300 opacity-30 rounded-full transform -translate-x-12 -translate-y-12 animate-pulse"></div>
      <div className="absolute bottom-14 right-6 w-32 h-32 bg-pink-300 opacity-30 rounded-full transform translate-x-16 translate-y-16 animate-pulse"></div>
      <div className="absolute top-1/4 left-1/4 w-16 h-16 bg-yellow-200 opacity-40 rounded-lg rotate-45 animate-spin-slow hidden md:block"></div>
      <div className="absolute bottom-1/4 right-1/4 w-20 h-20 bg-green-200 opacity-40 rounded-lg rotate-12 hidden md:block"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="md:text-5xl text-3xl font-bold text-gray-900">
            <span className="md:display block">Recommended </span>
            <span className="text-gray-600">by our {activeTab === 'student' ? 'students' : 'tutors'}</span>
          </h2>
        </div>

        <Slider {...settings}>
          {testimonials[activeTab].map((testimonial, index) => (
            <div key={index} className="px-2 h-60">
              <div className="bg-white p-6 h-56 w-96 rounded-lg shadow-md hover:bg-gray-800 hover:text-white transition-colors duration-300">
                <div className="space-y-4">
                  <div className="flex space-x-1">
                    {renderStars(testimonial.rating)}
                  </div>
                  <blockquote className="text-lg">
                    <p className="font-medium">“{testimonial.quote}”</p>
                  </blockquote>
                  <div>
                    <p className="font-semibold">{testimonial.name}</p>
                    <p className="text-sm text-gray-600 group-hover:text-gray-300">
                      {activeTab === 'student' ? 'Student' : 'Tutor'} from {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialSection;